<template>
    <form class="form-last-new form-horizontal" @submit.prevent="submit()">
        <div class="form-group">
            <label class="col-sm-2 control-label" :class="{'has-error': errors['date']}">Fecha y hora </label> 
            <div class="col-sm-10">
                <el-date-picker
                    v-model="data.date"
                    type="datetime"
                    format="dd-MM-yyyy HH:mm a"
                    placeholder="Seleccione una Fecha" >
                </el-date-picker>
                <div class="help-block" v-for="e in errors['date']">{{e}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-2 control-label" :class="{'has-error': errors['description']}">Descripción</label> 
            <div class="col-sm-10">
                <textarea class="form-control" id="description" v-model="data.description" rows="5"></textarea>
                 <div class="help-block" v-for="e in errors['description']">{{e}}</div>
            </div>    
        </div>
        <div class="form-group">
            <label class="col-sm-2 control-label" :class="{'has-error': errors['url']}">Url</label> 
            <div class="col-sm-10">
                <input type="text"  class="form-control" name="url" id="url" v-model="data.url" placeholder="http://" style="width: 100%;">    
                <div class="help-block" v-for="e in errors['url']">{{e}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-sm-2 control-label">Activo</label> 
            <div class="col-sm-10">
                <el-switch
                    v-model="data.active"
                    on-text="SI"
                    off-text="NO"                    
                    >
                </el-switch>
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" :href="'backend/ultimas-noticias'">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<script>
import ElementUI from 'element-ui';
import ElSwitch from 'element-ui/lib/switch';
import ElOption from 'element-ui/lib/option';
import ElDatePicker from 'element-ui/lib/date-picker';
import locale from 'element-ui/lib/locale/lang/es';
import Vue from 'vue';
import { Message } from 'element-ui';
Vue.use(ElementUI, { locale });

export default {
    
    data:function(){
        const today = moment().toDate();
        const lastnew = _.cloneDeep(this.lastnew);
        const description = null;
        const url = '';
        const active = false;


        const data = {
            date: today,
            description:description,
            url:url,
            active:active 
        }

        _.assign(data, this.lastnew);

        if(this.edit){
            data.date = moment(data.date).toDate();
        }

        return{
            data: data,
             errors: {}
        }
    },
    props:['lastnew', 'edit'],
    components:{
        ElSwitch,
        ElOption,
        ElDatePicker
    },
    methods:{
        submit:function(){
            var self = this;
            var date = !self.data.date;
            var description = self.data.description === '' || self.data.description === null;
            var url =  self.data.url === null || self.data.url.substring(0, 3) == "www" ;
            var errors= {};

            if(date){
                errors['date']= ["El campo Fecha y hora no puede estar vacío."];
            }
            if(description){
                errors['description']= ["El campo Descripción no puede estar vacío."];
            }
      
            if(url){
                errors['url']= ["El campo Url no puede estar vacío o sin iniciar con http..."];
            }
            
            if(date || description || url){
                self.errors = errors;
            }else{
                if(self.edit){
                    var url_axios = 'backend/ultimas-noticias/'+ self.data.id + 'update/' ;
                    var method_axios = 'PUT';
                }else{
                    var url_axios = 'backend/ultimas-noticias/create';
                    var method_axios = 'POST';
                }
                self.data.date = moment(self.data.date).subtract(3,'hours');
                axios({
                    url: url_axios,
                    method: method_axios,
                    data: self.data,
                }).then(function(response){
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    self.errors = error.response.data.errors;
                });
            }

        }
    }

}
</script>